<template>
  <div class="w-full sm:w-1/3 flex items-center gap-2">
    <div
      class="flex items-center border border-gray-300 rounded-lg px-3 py-2 bg-white flex-1 focus-within:ring-2 focus-within:ring-ds-button-color"
    >
      <span class="text-gray-400 mr-2">🔍</span>
      <input
        v-model="inputValue"
        type="text"
        placeholder="Search agent name..."
        class="w-full outline-none text-sm text-gray-700"
      />
    </div>
  </div>
</template>

<script>
import { computed } from "vue";

export default {
  props: {
    modelValue: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const inputValue = computed({
      get: () => props.modelValue,
      set: (val) => emit("update:modelValue", val),
    });

    return {
      inputValue,
    };
  },
};
</script>
